import React from 'react';
import { Link } from 'react-router-dom';
import styles from './CtaBand.module.css';

export default function CtaBand({
  title   = 'Projeniz için teklif almak ister misiniz?',
  sub     = 'Uzman ekibimiz 24 saat içinde size geri döner.',
  btnText = 'Ücretsiz Teklif Al',
  btnTo   = '/iletisim',
}) {
  return (
    <section className={styles.band}>
      <div className={styles.inner}>
        <div>
          <h2 className={styles.title}>{title}</h2>
          <p  className={styles.sub}>{sub}</p>
        </div>
        <Link to={btnTo} className={styles.btn}>{btnText}</Link>
      </div>
    </section>
  );
}
